import { siteConfig } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[650px] md:h-[750px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20creative%20studio%20with%20warm%20vibrant%20orange%20and%20coral%20gradient%20lighting%2C%20abstract%20geometric%20shapes%20floating%2C%20clean%20minimalist%20aesthetic%2C%20dynamic%20energy%2C%20young%20creative%20atmosphere%2C%20warm%20tones%2C%20professional%20cinematic%20lighting%2C%20depth%20of%20field%2C%20artistic%20composition&width=1920&height=900&seq=hero-bg-91short&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-background-50/90 text-sm font-medium">
            全网超5000万用户的选择
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-background-50 leading-tight mb-6">
          发现精彩短视频
          <br />
          <span className="text-accent-400">记录生活每一刻</span>
        </h1>

        <p className="text-background-50/80 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          {siteConfig.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={siteConfig.downloadUrl}
            className="w-full sm:w-auto px-8 py-4 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
          >
            <i className="ri-download-2-line mr-2"></i>
            立即下载91short
          </a>
          <a
            href="#features"
            className="w-full sm:w-auto px-8 py-4 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-base font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
            <i className="ri-arrow-down-line ml-2"></i>
          </a>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">5000万+</div>
            <div className="text-sm text-background-50/60 mt-1">活跃用户</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">200万+</div>
            <div className="text-sm text-background-50/60 mt-1">创作者</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">10亿+</div>
            <div className="text-sm text-background-50/60 mt-1">短视频</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}